import LandingHero from "@/components/landing/LandingHero";
import LandingVideoHero from "@/components/landing/LandingVideoHero";
import LandingHowItWorks from "@/components/landing/LandingHowItWorks";
import LandingCallDetails from "@/components/landing/LandingCallDetails";
import LandingProofStrip from "@/components/landing/LandingProofStrip";
import LandingAuthority from "@/components/landing/LandingAuthority";
import GrowthAnalysisForm from "@/components/landing/GrowthAnalysisForm";
import LandingCta from "@/components/landing/LandingCta";
import TestimonialCarousel from "@/components/landing/TestimonialCarousel";
import LandingGoogleReviews from "@/components/landing/LandingGoogleReviews";
import Footer from "@/components/Footer";

const ApplyPage = () => {
  return (
    <div className="min-h-screen">
      <LandingHero />
      <LandingVideoHero />
      <LandingHowItWorks />
      <LandingCallDetails />
      <LandingProofStrip />
      <LandingAuthority />
      <GrowthAnalysisForm />
      <TestimonialCarousel />
      <LandingGoogleReviews />
      <LandingCta />
      <Footer />
    </div>
  );
};

export default ApplyPage;
